
import {ø} from "../../util/objects.js";
import {nav1day, newProduct} from "../productUtils.js";
import {tr} from "../../ux/translations.js";
import {scalarProduct} from "../scalarProduct.js";
import {createUnitDescriptors} from "../../util/units.js";
import * as utc from "../../util/utc.js";
import {gaiaPath} from "../gaia.js";
import * as sources from "../sources.js";
import {buildScaleFromSegments} from "../../palette/palette.js";
import {resolveTimeCursor} from "../../util/dates.js";


const CRW_TIMELINE = [
    {
        type: "recurring_interval",
        start: "2014-01-01T00:00Z",  // UNDONE
        frequency: {days: 1},
    },
];

let palettes = {};

function crwPath(attr, type) {
    const parts = resolveTimeCursor(attr.time_cursor);
    const isNow = attr.time_cursor === "now";
    const dir = isNow ? "current" : utc.print(parts, "{YYYY}/{MM}");
    const timestamp = isNow ? "current" : utc.print(parts, "{YYYY}{MM}{DD}");
    const res = attr.hd_enabled ? "0.05" : "0.15";
    const file = `${timestamp}-${type}-crw-${res}.epak`;
    return gaiaPath("data/crw", dir, file);
}

function newCRWProduct() {
    return {
        sourceHTML: sources.crw,
        timeline: CRW_TIMELINE,
    };
}

const categories = [
    tr`No Stress`,          //  0
    tr`Bleaching Watch`,    //  1
    tr`Bleaching Warning`,  //  2
    tr`Alert Level 1`,      //  3
    tr`Alert Level 2`,      //  4
];

export function createBAALayer(attr) {
    return ø(newProduct(), nav1day(attr.time_cursor), newCRWProduct(), {
        type: "bleaching_alert_area",
        descriptionHTML: {
            name: tr`Bleaching Alert Area`,
            qualifier: "",
        },
        paths: [crwPath(attr, "baa")],
        builder: file => scalarProduct(file, /bleaching_alert_area/, {hasMissing: true}),
        unitDescriptors: createUnitDescriptors({
            "heat_stress_level": {type: "enum", elements: categories},
        }),
        scale: palettes.baa ??= buildScaleFromSegments([0, 4], [
            [0,  [  5, 122, 176]],
            [1,  [255, 255, 178]],
            [2,  [254, 204,  92]],
            [3,  [253, 141,  60]],
            [4,  [227,  26,  28]],
        ], 5),
        alpha: {single: 200, animated: 132},
    });
}

// export function createDHWLayer(attr) {
//     return ø(newProduct(), nav1day(attr.time_cursor), newCRWProduct(), {
//         type: "degree_heating_week",
//         descriptionHTML: {
//             name: tr`Degree Heating Week`,
//             qualifier: "",
//         },
//         paths: [crwPath(attr, "dhw")],
//         builder: file => scalarProduct(file, /degree_heating_week/, {hasMissing: true}),
//         unitDescriptors: createUnitDescriptors({
//             "°C weeks": {convert: x => x, precision: 2},
//         }),
//         scale: palettes.dhw ??= createDHWPalette()/*buildScaleFromSegments([0, 35], [
//             [0,  [  0,   0,   0]],
//             [35,  [255, 120, 0]]
//         ], 1000)*/,
//         alpha: {single: 200, animated: 132},
//     });
// }
//
// export function createDHWPalette() {
//     const bounds = [0, 35];
//     const interpolator = newInterpolator(interpolateCividis, "cubehelix", bounds);
//     const colors = quantize(bounds, [interpolator], 1000);
//     return buildScale(bounds, colors);
// }
